import { z } from "zod";
import { flag, id } from "./common";

export const noteEntityType = z.enum(["lead", "booking", "contact", "tour"]);
export const noteQuery = z.object({ entityType: noteEntityType, entityId: id });
export const noteCreate = noteQuery.extend({ body: z.string().trim().min(1).max(4000), pinned: flag.optional() });
/** Stored and internally composed notes preserve all validated source text and
 * provenance. Public/manual commands still use noteCreate's 4,000 limit. */
export const noteRecord = noteQuery.extend({ body: z.string().min(1), pinned: flag.optional() });
export const systemNoteCreate = noteRecord.extend({ body: noteRecord.shape.body.trim() });
export const notePatch = noteCreate.pick({ body: true, pinned: true }).partial().refine(p => Object.keys(p).length > 0, { message: "nothing to update" });
export type NoteCreate = z.infer<typeof noteCreate>;
export type NotePatch = z.infer<typeof notePatch>;
